import ColumnTypes from '@/utils/ColumnTypes';

export const getColums = that => {
	let arr = [
		{
			key: 'shopDetails',
			label: '达人信息',
			type: () => import('../tableCell/myTalentInfo'),
			fixed: 'left',
			minWidth: '250',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: true,
		},
		{
			key: 'fans_num',
			label: '粉丝数',
			type: 'rdText',
			bigger: true,
			minWidth: '100',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: true,
		},
		{
			key: 'fee_30',
			label: '30日销售额',
			type: 'rdText',
			minWidth: '170',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: that.$isKs(that.platformId) || that.$isSp(that.platformId),
		},

		{
			key: 'live_sale',
			label: '场均销售额',
			type: 'rdText',
			minWidth: '170',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: that.$isKs(that.platformId) || that.$isSp(that.platformId),
		},
		{
			key: 'goods_tag',
			label: '达人标签',
			type: () => import('../tableCell/goodsTag'),
			minWidth: '150',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: that.$auth.hasPermi('my-talent:search-tags'),
		},
		{
			key: 'partner_role_name',
			label: '跟进人',
			type: () => import('../tableCell/partnersName'),
			minWidth: '150',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: true,
		},
		{
			key: 'liveCommerce',
			label: '直播带货数据',
			type: () => import('../tableCell/liveCommerce'),
			minWidth: '200',
			helpNum: 3,
			helpDesc1: '场均销售额：近30天带货直播场次的平均GMV，剔除开播时间小于25分钟的直播',
			helpDesc2: '直播观看人数：近30天卖货直播的观看人数的中位数',
			helpDesc3: '直播带货场次：近30天带货直播场次数量，剔除开播时间小于25分钟的直播',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: that.$isDy(that.platformId),
		},
		{
			key: 'shortVideoCommerce',
			label: '短视频带货数据',
			type: () => import('../tableCell/shortVideoCommerce'),
			minWidth: '200',
			helpNum: 2,
			helpDesc1: '带货短视频：近30天发布且挂商品链接的短视频数量',
			helpDesc2: '带货商品数：近30天短视频带货的商品种类',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: that.$isDy(that.platformId),
		},

		{
			key: 'anchor_desc',
			label: '简介',
			type: 'rdText',
			minWidth: '200',
			ellipsisRow: 3,
			show: that.showStatus(1),
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
		},
		{
			key: 'contact_num',
			label: '建联次数',
			type: 'rdText',
			minWidth: '120',
			show: that.showStatus(1),
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
			helpNum: 1,
			helpDesc1: '添加达人微信不通过的次数',
		},
		{
			key: 'share_num',
			label: '推品次数',
			type: 'rdText',
			minWidth: '120',
			show: that.showStatus(2),
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
			helpNum: 1,
			helpDesc1: '小程序分享商品次数',
		},
		{
			key: 'open_percent',
			label: '打开率',
			type: 'rdText',
			minWidth: '100',
			show: that.showStatus(2),
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
			helpNum: 1,
			textType: 'percent',
			helpDesc1: '达人打开推品小程序的比率，即打开推广记录数/总推广记录数',
		},
		{
			key: 'recent_view_time',
			label: '最近查看时间',
			type: 'rdText',
			minWidth: '180',
			show: that.showStatus(2),
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
		},
		{
			key: 'apply_num',
			label: '申样数',
			type: 'rdText',
			minWidth: '100',
			helpNum: 1,
			helpDesc1: '已创建样品订单数',
			show: that.showStatus(3, 4),
			isAuth: true,
		},
		{
			key: 'send_num',
			label: '寄样数',
			type: 'rdText',
			minWidth: '100',
			helpNum: 1,
			helpDesc1: '已发货样品订单数',
			show: that.showStatus(3, 4),
			isAuth: true,
		},
		{
			key: 'delivery_num',
			label: '交付数',
			type: 'rdText',
			minWidth: '100',
			helpNum: 1,
			helpDesc1: '已交付合作关联的样品订单数',
			show: that.showStatus(4),
			isAuth: true,
		},
		{
			key: 'uneffect_reason',
			label: '失效原因',
			type: 'rdText',
			minWidth: '180',
			show: that.showStatus(5),
			isAuth: true,
		},
		{
			key: 'clue_time',
			label: '认领时间',
			type: 'rdText',
			minWidth: '170',
			show: that.showStatus(1, 2, 3, 4),
			isAuth: true,
		},
		{
			key: 'contact_time',
			label: '最近建联时间',
			type: 'rdText',
			minWidth: '170',
			helpNum: 1,
			helpDesc1: '最近一次添加达人的时间',
			show: that.showStatus(2, 3, 4),
			isAuth: true,
		},
		{
			key: 'recent_share_time',
			label: '最近推品时间',
			type: 'rdText',
			minWidth: '170',
			show: that.showStatus(2),
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
		},
		{
			key: 'last_apply_time',
			label: '最近申样时间',
			type: 'rdText',
			minWidth: '170',
			helpNum: 1,
			helpDesc1: '该达人最近申样行为的时间',
			show: that.showStatus(3),
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
		},
		{
			key: 'uneffect_time',
			label: '失效时间',
			type: 'rdText',
			minWidth: '170',
			show: that.showStatus(5),
			isAuth: true,
		},
		{
			key: 'add_time',
			label: '创建时间',
			type: 'rdText',
			minWidth: '170',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: true,
		},

		{
			key: 'remark',
			label: '备注',
			type: 'rdText',
			ellipsisRow: 3,
			minWidth: '180',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: true,
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '100',
			fixed: 'right',
			align: 'right',
			show: that.showStatus(1, 2, 3, 4, 5),
			isAuth: true,
		},
	];
	return arr;
};
